import { Col as ReactstrapCol, Row } from 'reactstrap';
import styled from 'styled-components';
import InlineSVG from 'svg-inline-react';

import CapsuleAccordion from 'src/app/components/Elements/Accordion';
import Button from 'src/app/components/Elements/Button';
import WhyPeopleLoveCapsule from 'src/app/components/PageSections/WhyPeopleLoveCapsule';

export const SubSubheaderSection = styled.div`
  color: white;
  margin-bottom: ${props => props.theme.space['10.0']};
  ${props => props.theme.mediaQueries.smallDown} {
    margin-top: 0;
    margin-bottom: 0;
  }

  font-family: ${props => props.theme.fonts.circular};
  font-weight: ${props => props.theme.fontWeights.bold};
  padding: ${props => props.theme.space.none} !important;
  font-size: ${props => props.theme.fontSizes.displayXL};
  line-height: ${props => props.theme.lineHeights.displayXL};

  ${props => props.theme.mediaQueries.mediumDown} {
    font-size: ${props => props.theme.fontSizes.headerOne};
    line-height: ${props => props.theme.lineHeights.headerOne};
  }
`;

export const StepsCol = styled(ReactstrapCol)`
  margin-bottom: ${props => props.theme.space.none};

  ${props => props.theme.mediaQueries.small} {
    margin-top: ${props => props.theme.space.s7};
  }

  ${props => props.theme.mediaQueries.large} {
    margin-bottom: 0;
    margin-top: 0;
  }
`;

export const StepsIcon = styled.img`
  margin: 0 auto ${props => props.theme.space['2.0']} auto;
`;

export const StepsIconPhone = styled.img`
  height: 100px;
  margin: 0 auto ${props => props.theme.space['4.0']} auto;
`;

export const ItemGrouping = styled.div`
  display: flex;
  flex-direction: row;
  text-align: left;
  justify-content: space-around;
  align-items: center;

  ${props => props.theme.mediaQueries.large} {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
`;

export const IconsRow = styled(Row)`
  display: flex;
  align-items: center;
  height: 100%;
  min-height: 308px;
`;

export const FixedNav = styled.div<{ opacity: number }>`
  display: ${props => (props.opacity === 0 ? 'none' : 'flex')};
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  padding: ${props => props.theme.space.s5};
  z-index: 999;
  box-shadow: 0px -2px 4px rgba(22, 50, 80, 0.08), 0px -4px 8px rgba(0, 117, 102, 0.08);
  opacity: ${props => props.opacity};

  ${props => props.theme.mediaQueries.small} {
    display: none;
  }
`;

export const MobileButton = styled(Button)<{ isHidden?: boolean }>`
  width: 100%;
  margin: 0 !important;

  &:active {
    background-color: ${props => props.theme.colors.capsuleBlue50} !important;
    color: #fff !important;
    pointer-events: cursor;
  }

  &:focus {
    background-color: #fff !important;
    color: ${props => props.theme.colors.capsuleBlue50} !important;
    box-shadow: 0 0 0 0 !important;
  }

  display: ${props => (props.isHidden ? 'none' : '')};
`;

export const PillTriangle = styled(InlineSVG)`
  display: none;

  ${props => props.theme.mediaQueries.small} {
    position: absolute;
    width: 35rem;
    top: 26rem;
    right: -15rem;
    display: block;
  }

  svg {
    fill: #ef4931;
  }
`;

export const PillCrossed = styled(InlineSVG)`
  position: absolute;
  width: 35rem;
  right: -25rem;
  bottom: -12rem;

  ${props => props.theme.mediaQueries.small} {
    right: 12rem;
  }

  svg {
    fill: #99bfbc;
  }
`;

export const PillTall = styled(InlineSVG)`
  position: absolute;
  width: 35rem;
  bottom: -51rem;
  left: -25rem;

  svg {
    fill: #ffd300;
  }
`;

export const Accordion = styled(CapsuleAccordion)`
  padding: 0;
  margin-bottom: ${props => props.theme.space.s9};
  z-index: 1;
  max-width: '116rem';
`;

export const TextContainer = styled.div`
  margin-bottom: ${props => props.theme.space.s7};

  ${props => props.theme.mediaQueries.small} {
    margin-bottom: ${props => props.theme.space.s8};
  }
`;

export const IconTextContainer = styled.div`
  width: 214px;
`;

export const FullServicePharmacy = styled(WhyPeopleLoveCapsule)`
  &&& {
    ${props => props.theme.mediaQueries.small} {
      padding: 0 0 ${props => props.theme.space.s9};

      & > .container {
        margin-left: 0px;
        margin-right: 0px;
      }
    }
  }
`;

export const OtcBox = styled.div`
  border: 0;
  padding: 0 ${props => props.theme.space['10.0']} 0 ${props => props.theme.space['10.0']} 0;

  .otc-name {
    height: ${props => props.theme.space['6.0']};
    ${props => props.theme.mediaQueries.mediumDown} {
      height: ${props => props.theme.space['8.0']};
    }
  }
`;

export const OtcCarousel = styled.div`
  img {
    width: 15vw;
    height: 15vw;
    ${props => props.theme.mediaQueries.mediumDown} {
      width: 20vw;
      height: 20vw;
    }
    object-fit: contain;
  }
`;

export const LogoSectionDesktop = styled.img`
  align-self: flex-start;
  width: 90%;
  ${props => props.theme.mediaQueries.smallDown} {
    display: none;
  }
`;

export const LogoSectionMobile = styled.img`
  align-self: flex-start;
  width: 90%;
  display: none;
  ${props => props.theme.mediaQueries.smallDown} {
    display: block;
  }
`;

export const OrderedList = styled.ol`
  counter-reset: item;
  margin-left: ${props => props.theme.space.none};
  padding-left: ${props => props.theme.space.none};
`;

export const OrderedListItem = styled.li`
  display: block;
  margin-bottom: ${props => props.theme.space.s3};
  margin-left: ${props => props.theme.space.s5};
  &:before {
    display: inline-block;
    content: counter(item) '. ';
    counter-increment: item;
    width: ${props => props.theme.space.s5};
    margin-left: -${props => props.theme.space.s5};
  }
`;

export const RSymbol = styled.span`
  vertical-align: super !important;
  font-size: ${props => props.theme.fontSizes.small} !important;
`;

export const InlineBlockContent = styled.span`
  display: inline-block;
`;
